import {SidompulService} from "@/services/sidompul.service"

const state ={
  soon: false,
  loading: false,
  overlay: false,
  loadingAddKategori: false,
  loadingMenuDeleteAkun: false,
  modal_aktivasi: false,
  sidompuls: [],
  totaldata: 1,
  totalpage: 1,
  count: 0
}

const actions = {
  getSidompulData({commit}){
    commit('setloading',true);
    if(state.sidompuls.length !== 0) commit('setPendings',[]);
    SidompulService.getSidompulUrl().then(data => {
      commit("setSidompul", data)
      commit('setloading',false);
    }).catch(err => {
      console.log(err)
      commit('setloading',false);
    })
  },

  openCloseModal({commit}){
    commit("setModalBoolean", !state.modal_aktivasi)
  },

  updateUrlModule({commit, dispatch},opt){
    commit("setModalBoolean", !state.modal_aktivasi)
    if(!opt.url_module) dispatch('alert/error', "Url module tidak boleh kosong", { root: true });
    else{
      commit('setloading',true);
      commit("setSidompul", [])
      SidompulService.updateUrlModuleSidompul(opt).then (data => {
        dispatch('alert/success', data.msg, { root: true });
        SidompulService.getSidompulUrl().then(data => {
          commit("setSidompul", data)
          commit('setloading',false);
        }).catch(err => {
          console.log("=====ERROR getIsimpleData=====")
          console.log(err)
        })
      }).catch(err => {
        dispatch('alert/error', "Internal server error", { root: true });
        console.log("=====ERROR updateUrlModuleIsimple=====")
        console.log(err)
      })
    }
  }
}

const mutations = {
  setSidompul(state, value){
    state.sidompuls = value.data;
  },
  setloading(state,load) {
    state.loading = load
    state.overlay = load
  },
  setPendingCount(state,load){
    state.count = load
  },
  setPendings(state,load){
    state.sidompuls=load
  },
  setModalBoolean(state,load){
    state.modal_aktivasi = load
  }
}

export const Sidompul = {
  namespaced: true,
  state,
  actions,
  mutations
};
